// import i18n from './i18n'

/** Maximum width considered to still be in "mobile mode." */
export const MAX_MOBILE_MODE_WIDTH = 768 - 1 // 768 = "medium" scss breakpoint

export const LATEST_APP_VERSION = '1.1.0'

export const APP_STORE_LINK =
  'https://apps.apple.com/us/app/upchieve/id1506076042'

export const GOOGLE_PLAY_STORE_LINK =
  'https://play.google.com/store/apps/details?id=org.upchieve.mobile'

export const CDN_URL = 'https://upchievecdn.blob.core.windows.net'

export const DOCS_URL = `${CDN_URL}/docs`

export const GRADES_NEW = [
  { label: '6th grade', value: '6th grade' },
  { label: '7th grade', value: '7th grade' },
  { label: '8th grade', value: '8th grade' },
  { label: '9th grade', value: '9th grade' },
  { label: '10th grade', value: '10th grade' },
  { label: '11th grade', value: '11th grade' },
  { label: '12th grade', value: '12th grade' },
  { label: 'College', value: 'College' },
  { label: 'Other', value: 'Other' },
]

export const FA_GRADES_NEW = [
  { label: 'کلاس ششم', value: '6th grade' },
  { label: 'کلاس هفتم', value: '7th grade' },
  { label: 'کلاس هشتم', value: '8th grade' },
  { label: 'کلاس نهم', value: '9th grade' },
  { label: 'کلاس دهم', value: '10th grade' },
  { label: 'کلاس یازدهم', value: '11th grade' },
  { label: 'کلاس دوازدهم', value: '12th grade' },
  { label: 'پیش دانشگاهی', value: 'College' },
  { label: 'دیگر', value: 'Other' },
]

export const GRADES = [
  '6th grade',
  '7th grade',
  '8th grade',
  '9th grade',
  '10th grade',
  '11th grade',
  '12th grade',
  'College',
  'Other',
  // i18n.t('const.grades.6thGrade'),
  // i18n.t('const.grades.7thGrade'),
  // i18n.t('const.grades.8thGrade'),
  // i18n.t('const.grades.9thGrade'),
  // i18n.t('const.grades.10thGrade'),
  // i18n.t('const.grades.11thGrade'),
  // i18n.t('const.grades.12thGrade'),
  // i18n.t('const.grades.college'),
  // i18n.t('const.grades.other'),
]

export const STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
]

export const COUNTRIES = [
  'United States of America',
  'Afghanistan',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia (Plurinational State of)',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cabo Verde',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo (the Democratic Republic of the)',
  'Congo',
  'Cook Islands',
  'Costa Rica',
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czechia',
  "Côte d'Ivoire",
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Eswatini',
  'Ethiopia',
  'Falkland Islands',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran (Islamic Republic of)',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea (the Democratic People's Republic of)",
  'Korea (the Republic of)',
  'Kuwait',
  'Kyrgyzstan',
  "Lao People's Democratic Republic",
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia (Federated States of)',
  'Moldova (the Republic of)',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine, State of',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Republic of North Macedonia',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Réunion',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin (French part)',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and the South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom of Great Britain and Northern Ireland',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela (Bolivarian Republic of)',
  'Viet Nam',
  'Virgin Islands (British)',
  'Virgin Islands (U.S.)',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
  'Aland Islands',
]

export const STATES_WITH_ABBREVIATIONS = [
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'American Samoa', value: 'AS' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'States of Micronesia', value: 'FM' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Guam', value: 'GU' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Marshall Islands', value: 'MH' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Northern Mariana Islands', value: 'MP' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Palau', value: 'PW' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virgin Islands', value: 'VI' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
]

// user events in a [noun][verb] format
export const EVENTS = {
  ACCOUNT_CREATED: 'ACCOUNT_CREATED',
  ACCOUNT_DEACTIVATED: 'ACCOUNT_DEACTIVATED',
  ACCOUNT_VERIFIED: 'ACCOUNT_VERIFIED',
  AVAILABILITY_UPDATED: 'AVAILABILITY_UPDATED',
  BACKGROUND_INFORMATION_COMPLETED: 'BACKGROUND_INFORMATION_COMPLETED',
  // @note: eligibility does not follow [noun][verb] format
  ELIGIBILITY_ELIGIBLE: 'ELIGIBILITY_ELIGIBLE',
  ELIGIBILITY_INELIGIBLE: 'ELIGIBILITY_INELIGIBLE',
  PHOTO_ID_ADDED: 'PHOTO_ID_ADDED',
  PROFILE_UPDATED: 'PROFILE_UPDATED',
  POST_SESSION_SURVEY_SUBMITTED: 'POST_SESSION_SURVEY_SUBMITTED',
  QUIZ_STARTED: 'QUIZ_STARTED',
  QUIZ_PASSED: 'QUIZ_PASSED',
  QUIZ_FAILED: 'QUIZ_FAILED',
  REFERENCE_ADDED: 'REFERENCE_ADDED',
  REFERENCE_FORM_SUBMITTED: 'REFERENCE_FORM_SUBMITTED',
  REVIEW_MATERIALS_VIEWED: 'REVIEW_MATERIALS_VIEWED',
  SESSION_ENDED: 'SESSION_ENDED',
  SESSION_REQUESTED: 'SESSION_REQUESTED',
  SESSION_TIMED_OUT_15_MINS: 'SESSION_TIMED_OUT_15_MINS',
  SESSION_TIMED_OUT_45_MINS: 'SESSION_TIMED_OUT_45_MINS',
  STUDENT_SHOWN_ONBOARDING_MODAL: 'STUDENT_SHOWN_ONBOARDING_MODAL',
  STUDENT_FINISHED_ONBOARDING_MODAL: 'STUDENT_FINISHED_ONBOARDING_MODAL',
  STUDENT_CLICKED_CANT_FIND_SCHOOL: 'STUDENT_CLICKED_CANT_FIND_SCHOOL',
  STUDENT_CLICKED_CHECK_MY_ELIGIBILITY: 'STUDENT_CLICKED_CHECK_MY_ELIGIBILITY',
  STUDENT_CLICKED_STUDENT_ACCESS_PAGE: 'STUDENT_CLICKED_STUDENT_ACCESS_PAGE',
  STUDENT_ENTERED_EMAIL: 'STUDENT_ENTERED_EMAIL',
  STUDENT_ENTERED_FIRST_NAME: 'STUDENT_ENTERED_FIRST_NAME',
  STUDENT_ENTERED_INVALID_PASSWORD: 'STUDENT_ENTERED_INVALID_PASSWORD',
  STUDENT_ENTERED_LAST_NAME: 'STUDENT_ENTERED_LAST_NAME',
  STUDENT_ENTERED_PASSWORD: 'STUDENT_ENTERED_PASSWORD',
  STUDENT_ENTERED_ZIP_CODE: 'STUDENT_ENTERED_ZIP_CODE',
  STUDENT_SEARCHED_SCHOOL: 'STUDENT_SEARCHED_SCHOOL',
  STUDENT_SELECTED_SCHOOL: 'STUDENT_SELECTED_SCHOOL',
  STUDENT_VISITED_DEACTIVATED_PARTNER: 'STUDENT_VISITED_DEACTIVATED_PARTNER',
  STUDENT_TELL_THEM_CP_MODAL_SHOWN: 'STUDENT_TELL_THEM_CP_MODAL_SHOWN',
  STUDENT_TELL_THEM_CP_REMINDER: 'STUDENT_TELL_THEM_CP_REMINDER',
  STUDENT_TELL_THEM_CP_STARTED_SESSION: 'STUDENT_TELL_THEM_CP_STARTED_SESSION',
  STUDENT_TELL_THEM_CP_ENTERED_REMINDER_DATE:
    'STUDENT_TELL_THEM_CP_ENTERED_REMINDER_DATE',
  STUDENT_TELL_THEM_CP_CLICKED_REMIND_ME:
    'STUDENT_TELL_THEM_CP_CLICKED_REMIND_ME',
  STUDENT_TELL_THEM_CP_CLICKED_NOT_INTERESTED:
    'STUDENT_TELL_THEM_CP_CLICKED_NOT_INTERESTED',
  STUDENT_TELL_THEM_CP_CANCEL_CONFIRMATION:
    'STUDENT_TELL_THEM_CP_CANCEL_CONFIRMATION',
  STUDENT_TELL_THEM_CP_CLICKED_DONT_REMIND_ME:
    'STUDENT_TELL_THEM_CP_CLICKED_DONT_REMIND_ME',
  STUDENT_TELL_THEM_CP_CLICKED_BACK_BUTTON:
    'STUDENT_TELL_THEM_CP_CLICKED_BACK_BUTTON',
  STUDENT_TYPED_IN_COACH_REACH_OUT_TEXT_BOX:
    'STUDENT_TYPED_IN_COACH_REACH_OUT_TEXT_BOX',
  STUDENT_SENT_COACH_REACH_OUT_MESSAGE: 'STUDENT_SENT_COACH_REACH_OUT_MESSAGE',
  VOLUNTEER_CLICKED_ABOUT_SESSION: 'VOLUNTEER_CLICKED_ABOUT_SESSION',
  VOLUNTEER_FAST_TRACKED: 'VOLUNTEER_FAST_TRACKED',
  VOLUNTEER_VISITED_DEACTIVATED_PARTNER:
    'VOLUNTEER_VISITED_DEACTIVATED_PARTNER',
  MATERIAL_COMPLETED: 'MATERIAL_COMPLETED',
  MATERIAL_VIEWED: 'MATERIAL_VIEWED',
  FLAGGED_AS_AUTO_FLOW_STEP_TWO_PROGRESS_BAR:
    'FLAGGED_AS_AUTO_FLOW_STEP_TWO_PROGRESS_BAR',
  FLAGGED_AS_AUTO_FLOW_STEP_TWO_AVAILBILITY_STEP:
    'FLAGGED_AS_AUTO_FLOW_STEP_TWO_AVAILBILITY_STEP',
  VOLUNTEER_CLICKED_QUIZ_STUDY_MATERIALS:
    'VOLUNTEER_CLICKED_QUIZ_STUDY_MATERIALS',
  USER_DOES_NOT_HAVE_LINKED_GOOGLE_ACCOUNT:
    'USER_DOES_NOT_HAVE_LINKED_GOOGLE_ACCOUNT',
  USER_CLICKED_SIGN_IN_WITH_GOOGLE: 'USER_CLICKED_SIGN_IN_WITH_GOOGLE',
  PARTNER_STUDENT_CLICKED_SIGN_UP_WITH_GOOGLE:
    'PARTNER_STUDENT_CLICKED_SIGN_UP_WITH_GOOGLE',
  USER_CLICKED_SIGN_UP_WITH_GOOGLE: 'USER_CLICKED_SIGN_UP_WITH_GOOGLE',
  USER_VISITED_REFERRAL_LINK: 'STUDENT_VISITED_REFERRAL_LINK',
  STUDENT_CLICKED_TO_GET_REFERRAL_LINK_CARD:
    'STUDENT_CLICKED_TO_GET_REFERRAL_LINK_CARD',
  STUDENT_SHOWN_REFERRAL_MODAL: 'STUDENT_SHOWN_REFERRAL_MODAL',
  STUDENT_CLICKED_REFER_A_FRIEND: 'STUDENT_CLICKED_REFER_A_FRIEND',
  STUDENT_COPIED_REFERRAL_LINK: 'STUDENT_COPIED_REFERRAL_LINK',
  USER_CLICKED_IN_SESSION_HELP: 'USER_CLICKED_IN_SESSION_HELP',
  CC_STUDENT_CLICKED_UPCHIEVE_LINK: 'CC_STUDENT_CLICKED_UPCHIEVE_LINK',
  STUDENT_PROCRASTINATION_PREVENTION_MODAL_CLOSED:
    'STUDENT_PROCRASTINATION_PREVENTION_MODAL_CLOSED',
  STUDENT_PROCRASTINATION_PREVENTION_SHOWN_CANCEL_CONFIRMATION:
    'STUDENT_PROCRASTINATION_PREVENTION_SHOWN_CANCEL_CONFIRMATION',
  STUDENT_PROCRASTINATION_PREVENTION_CANCEL_CONFIRMED:
    'STUDENT_PROCRASTINATION_PREVENTION_CANCEL_CONFIRMED',
  STUDENT_PROCRASTINATION_PREVENTION_CLICKED_NOT_STRUGGLING:
    'STUDENT_PROCRASTINATION_PREVENTION_CLICKED_NOT_STRUGGLING',
  STUDENT_PROCRASTINATION_PREVENTION_CLICKED_STRUGGLING:
    'STUDENT_PROCRASTINATION_PREVENTION_CLICKED_STRUGGLING',
  STUDENT_PROCRASTINATION_PREVENTION_PHONE_SUBMITTED:
    'STUDENT_PROCRASTINATION_PREVENTION_PHONE_SUBMITTED',
  STUDENT_PROCRASTINATION_PREVENTION_CLICKED_REMIND_ME:
    'STUDENT_PROCRASTINATION_PREVENTION_CLICKED_REMIND_ME',
  STUDENT_PROCRASTINATION_PREVENTION_CLICKED_CHANGE_REMINDER_DATE:
    'STUDENT_PROCRASTINATION_PREVENTION_CLICKED_CHANGE_REMINDER_DATE',
  STUDENT_PROCRASTINATION_PREVENTION_CHANGED_REMINDER_DATE:
    'STUDENT_PROCRASTINATION_PREVENTION_CHANGED_REMINDER_DATE',
  STUDENT_PROCRASTINATION_PREVENTION_REMINDER_SUBMITTED:
    'STUDENT_PROCRASTINATION_PREVENTION_REMINDER_SUBMITTED',
  STUDENT_PROCRASTINATION_PREVENTION_MODAL_SHOWN:
    'STUDENT_PROCRASTINATION_PREVENTION_MODAL_SHOWN',
  STUDENT_PROCRASTINATION_PREVENTION_CLICKED_DONT_REMIND_ME:
    'STUDENT_PROCRASTINATION_PREVENTION_CLICKED_DONT_REMIND_ME',
  STUDENT_PROCRASTINATION_PREVENTION_RETURNED_FROM_REMINDER:
    'STUDENT_PROCRASTINATION_PREVENTION_RETURNED_FROM_REMINDER',
  STUDENT_PROCRASTINATION_PREVENTION_CANCEL_CUSTOM_DATE:
    'STUDENT_PROCRASTINATION_PREVENTION_CANCEL_CUSTOM_DATE',
  STUDENT_FALL_INCENTIVE_PROGRAM_PHONE_NUMBER_MODAL_SHOWN:
    'STUDENT_FALL_INCENTIVE_PROGRAM_PHONE_NUMBER_MODAL_SHOWN',
  STUDENT_FALL_INCENTIVE_PROGRAM_PHONE_NUMBER_SUBMITTED:
    'STUDENT_FALL_INCENTIVE_PROGRAM_PHONE_NUMBER_SUBMITTED',
  STUDENT_FALL_INCENTIVE_PROGRAM_MODAL_CLOSED:
    'STUDENT_FALL_INCENTIVE_PROGRAM_MODAL_CLOSED',
  STUDENT_FALL_INCENTIVE_ENROLLMENT_MODAL_SHOWN:
    'STUDENT_FALL_INCENTIVE_ENROLLMENT_MODAL_SHOWN',
  STUDENT_FALL_INCENTIVE_ENROLLMENT_MODAL_CLOSED:
    'STUDENT_FALL_INCENTIVE_ENROLLMENT_MODAL_CLOSED',
  STUDENT_FALL_INCENTIVE_ENROLLMENT_VERIFICATION_CODE_SENT:
    'STUDENT_FALL_INCENTIVE_ENROLLMENT_VERIFICATION_CODE_SENT',
  STUDENT_FALL_INCENTIVE_ENROLLMENT_VERIFICATION_CODE_RESENT:
    'STUDENT_FALL_INCENTIVE_ENROLLMENT_VERIFICATION_CODE_RESENT',
  STUDENT_FALL_INCENTIVE_ENROLLMENT_PHONE_CONFIRMED:
    'STUDENT_FALL_INCENTIVE_ENROLLMENT_PHONE_CONFIRMED',
  STUDENT_FALL_INCENTIVE_ENROLLMENT_ENROLLED:
    'STUDENT_FALL_INCENTIVE_ENROLLMENT_ENROLLED',
  PHONE_NUMBER_UPDATED: 'PHONE_NUMBER_UPDATED',
  SMS_OPTED_IN: 'SMS_OPTED_IN',
  SMS_OPTED_OUT: 'SMS_OPTED_OUT',
  SMS_CONSENT_CHECKBOX_CHANGED: 'SMS_CONSENT_CHECKBOX_CHANGED',
  PHONE_NUMBER_VERIFIED: 'PHONE_NUMBER_VERIFIED',
  PHONE_NUMBER_VERIFICATION_MODAL_OPENED:
    'PHONE_NUMBER_VERIFICATION_MODAL_OPENED',
  VOLUNTEER_OPENED_SESSION_HISTORY: 'VOLUNTEER_OPENED_SESSION_HISTORY',
  VOLUNTEER_OPENED_SESSION_RECAP: 'VOLUNTEER_OPENED_SESSION_RECAP',
  VOLUNTEER_CLICKED_PREVIOUS_SESSION_HISTORY_PAGE:
    'VOLUNTEER_CLICKED_PREVIOUS_SESSION_HISTORY_PAGE',
  VOLUNTEER_CLICKED_NEXT_SESSION_HISTORY_PAGE:
    'VOLUNTEER_CLICKED_NEXT_SESSION_HISTORY_PAGE',
  CHAT_BOT_GIVE_RESOURCES_MESSAGE_SHOWN:
    'CHAT_BOT_GIVE_RESOURCES_MESSAGE_SHOWN',
  CHAT_BOT_SEE_YOU_SOON_MESSAGE_SHOWN: 'CHAT_BOT_SEE_YOU_SOON_MESSAGE_SHOWN',
  SESSION_RECAP_DM_REPORT_MODAL_SHOWN: 'SESSION_RECAP_REPORT_MODAL_SHOWN',
  SESSION_RECAP_DM_REPORT_MODAL_SUBMITTED:
    'SESSION_RECAP_DM_REPORT_MODAL_SUBMITTED',
  BF_STUDENT_CLICKED_LEARN_MORE: 'BF_STUDENT_CLICKED_LEARN_MORE',
  BF_STUDENT_CLICKED_START_COLLEGE_SESSION:
    'BF_STUDENT_CLICKED_START_COLLEGE_SESSION',
  BF_STUDENT_SHOWED_START_COLLEGE_SESSION:
    'BF_STUDENT_SHOWED_START_COLLEGE_SESSION',
  SCORECASTER_MODAL_SHOWN: 'SCORECASTER_MODAL_SHOWN',
  SCORECASTER_MODAL_CLOSED: 'SCORECASTER_MODAL_CLOSED',
  SCORECASTER_ANALYSIS_STARTED: 'SCORECASTER_ANALYSIS_STARTED',
  SCORECASTER_ANALYSIS_RECEIVED: 'SCORECASTER_ANALYSIS_RECEIVED',
  SCORECASTER_STUDENT_CLICKED_DETAILED_REPORT:
    'SCORECASTER_STUDENT_CLICKED_DETAILED_REPORT',
  SCORECASTER_STUDENT_REQUESTED_HELP: 'SCORECASTER_STUDENT_REQUESTED_HELP',
  SCORECASTER_ANALYSIS_ERROR: 'SCORECASTER_ANALYSIS_ERROR',
  SCORECASTER_NO_ANALYSIS: 'SCORECASTER_NO_ANALYSIS',
  SKIPPING_ELIGIBILITY_EMAIL: 'SKIPPING_ELIGIBILITY_EMAIL',
  VERIFICATION_HEADER_CLICKED: 'VERIFICATION_HEADER_CLICKED',
  VERIFICATION_MODAL_OPENED: 'VERIFICATION_MODAL_OPENED',
  EMAIL_VERIFIED: 'EMAIL_VERIFIED',
  EMAIL_UPDATED: 'EMAIL_UPDATED',
}

export const VERIFICATION_METHOD = {
  SMS: 'sms',
  EMAIL: 'email',
}

export const UNLEASH_FEATURE_FLAGS = {
  REFER_FRIENDS: 'refer-friends',
  DASHBOARD_REDESIGN: 'dashboard-redesign',
  CHATBOT: 'chatbot',
}

export const POSTHOG_FEATURE_FLAGS = {
  DASHBOARD_BANNER: 'dashboard-banner',
  FILTER_ACTIVE_SUBJECTS: 'filter-active-subjects',
  POLL_FLAGS: 'polling-flags',
  QUIZ_STUDY_MATERIALS: 'quiz-study-materials',
  OFFER_GOOGLE_SSO: 'offer-google-sso',
  ORBITAL_SEGMENTS: 'orbital-segments',
  DOWNTIME_BANNER: 'downtime-banner',
  TOPIC_CARD_DASHBOARD_REORDER: 'topic-card-dashboard-reorder',
  SUBJECT_REQUEST_ROLLOUT: 'subject-request-rollout',
  QUIZ_ROLLOUT: 'quiz-rollout',
  STUDENT_COACH_REACH_OUT: 'student-coach-reach-out',
  CC_INTRO_COPY: 'cc-intro-copy',
  BF_INTRO_COPY: 'bf-intro-copy',
  PROCRASTINATION_PREVENTION: 'procrastination-prevention',
  MUTED_SUBJECT_ALERTS: 'muted-subject-alerts',
  FALL_INCENTIVE_ENROLLMENT: 'fall-incentive-enrollment',
  REFERRAL_COPY: 'referral-copy',
  TUTOR_SESSION_HISTORY: 'tutor-session-history',
  SESSION_RECAP_DMS: 'session-recap-dms',
  DASHBOARD_REDESIGN: 'dashboard-redesign',
  FORCE_DASHBOARD_REDESIGN_ORG: 'force-dashboard-redesign-org',
  RECAP_SOCKET_UPDATES: 'recap-socket-updates',
  SCORECASTER_WOZ: 'scorecaster-woz',
  AUTO_START_COLLEGE_SESSION: 'auto-start-college-session',
  SCORECASTER_MODAL: 'scorecaster-modal',
  SMS_VERIFICATION: 'sms-verification',
  ELIGIBILITY_EMAIL: 'eligibility-email',
  NEW_ELIGIBILITY_FORM_DESIGN: 'new-eligibility-form-design',
  SMS_VERIFICATION_ENABLED_ON_SIGNUP_FLOW:
    'sms-verification-enabled-on-signup-flow',
}

export const ANALYTICS_REPORT_ROW = {
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  EMAIL: 'Email',
  STATE: 'State of residence',
  ONBOARDING_STATUS: 'Onboarding status',
  DATE_ACCOUNT_CREATED: 'Date of account creation',
  DATE_ONBOARDED: 'Date onboarded',
  DATE_FIRST_SESSION: 'Date of first session',
  CERTIFICATIONS_RECEIVED: 'Certifications received',
  MATH_CERTS_RECEIVED: 'Math certs received',
  SCIENCE_CERTS_RECEIVED: 'Science certs received',
  COLLEGE_CERTS_RECEIVED: 'College counseling received',
  TOTAL_TEXTS_RECEIVED: 'Total texts received',
  TOTAL_SESSIONS_COMPLETED: 'Total sessions completed',
  TOTAL_UNIQUE_STUDENTS_HELPED: 'Total unique students helped',
  TOTAL_TUTORING_HOURS: 'Total tutoring hours',
  TOTAL_TRAINING_HOURS: 'Total training hours',
  TOTAL_ELAPSED_AVAILABILITY_HOURS: 'Total elapsed availability hours',
  TOTAL_VOLUNTEER_HOURS: 'Total hours',
  DATE_RANGE_TEXTS_RECEIVED: 'Texts received within date range',
  DATE_RANGE_SESSIONS_COMPLETED: 'Sessions completed within date range',
  DATE_RANGE_UNIQUE_STUDENTS_HELPED: 'Unique students helped within date range',
  DATE_RANGE_TUTORING_HOURS: 'Tutoring hours within date range',
  DATE_RANGE_TRAINING_HOURS: 'Training hours within date range',
  DATE_RANGE_ELAPSED_AVAILABILITY_HOURS:
    'Elapsed availability hours within date range',
  DATE_RANGE_VOLUNTEER_HOURS: 'Total hours within date range',
}

export const ANALYTICS_REPORT_SUMMARY = {
  DATE_RANGE_SIGN_UPS: 'New sign-ups',
  DATE_RANGE_VOLUNTEERS_ONBOARDED: 'Volunteers onboarded',
  DATE_RANGE_TEXT_RECEIVED: 'Tutoring opportunities provided',
  DATE_RANGE_SESSIONS_COMPLETED: 'Sessions completed',
  DATE_RANGE_VOLUNTEER_HOURS: 'Volunteer hours completed',
  DATE_RANGE_UNIQUE_STUDENTS_HELPED: 'Unique students helped',
  TOTAL_SIGN_UPS: 'Total sign-ups',
  TOTAL_VOLUNTEERS_ONBORDED: 'Total volunteers onboarded',
  TOTAL_TEXTS_RECEIVED: 'Total tutoring opportunities provided',
  TOTAL_SESSIONS_COMPLETED: 'Total sessions completed',
  TOTAL_VOLUNTEER_HOURS: 'Total volunteer hours completed',
  TOTAL_UNIQUE_STUDENTS_HELPED: 'Total unique students helped',
}

export const QUESTION_TYPES = {
  multipleChoice: 'multiple choice',
  checkBox: 'check box',
  freeResponse: 'free response',
}

export const SESSION_TOOL_TYPES = {
  DOCUMENT_EDITOR: 'documenteditor',
  WHITEBOARD: 'whiteboard',
}
